module.exports = __webpack_public_path__ + "static/media/fly0005.b8eaa960.webp";